import { render } from "./spendingActivityRecorderDetail.vue?vue&type=template&id=2ac124d2&ts=true"
import script from "./spendingActivityRecorderDetail.vue?vue&type=script&lang=ts"
export * from "./spendingActivityRecorderDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__